import { render } from "./AllCustomerAccountReport.vue?vue&type=template&id=0c4bbb8d&ts=true"
import script from "./AllCustomerAccountReport.vue?vue&type=script&lang=ts"
export * from "./AllCustomerAccountReport.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/trend/MANARATFOUNDATION/KRC-FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__